export default __webpack_public_path__ + "static/media/hdd.bcb77bb0.png";